import { call, put } from 'redux-saga/effects';
import { photoCaptureIntelligentImageContentDetectionFailureAction, photoCaptureIntelligentImageContentDetectionSuccessAction } from '../actions';
import { PhotoCaptureIntelligentImageContentDetectionService } from '../services';
import { getErrorMessagesBasedOnStatusCode } from '../utilities';
export function* photoCaptureIntelligentImageContentDetectionSaga(action) {
    try {
        const imageContentDetectionService = new PhotoCaptureIntelligentImageContentDetectionService();
        const response = yield call([imageContentDetectionService, imageContentDetectionService.photoCaptureIntelligentGetImageContentDetection], action.payload);
        yield put(photoCaptureIntelligentImageContentDetectionSuccessAction(response));
    }
    catch (error) {
        const errorMessage = getErrorMessagesBasedOnStatusCode(error);
        yield put(photoCaptureIntelligentImageContentDetectionFailureAction(errorMessage));
    }
}
//# sourceMappingURL=intelligentPhotoCaptureImageContentDetectionSaga.js.map